export default __webpack_public_path__ + "media/images/mailer-new/store-icons/btn-app-store-f087e8d67576706fcc54ce6a9b32670f.png";